export { default as CheckoutShipment } from './CheckoutShipment'



// WEBPACK FOOTER //
// ./src/Components/checkout/Features/ShippingMethod/index.js